import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])




export const GenericComputed = {
 
  ...mapGetters('auth', ['JWToken','UserRolles','UserNameSurName','Avatar','AvatarUrl','UserFirsName','UserLastName','UserEmail']),
}
export const MethodsFastReport = mapActions('ecampus', ['FastReport'])
export const MethodsStrGet = mapActions('ecampus', ['ActionsGet'])
export const MethodsStrSingleGet = mapActions('ecampus', ['ActionsSingleGet'])
export const MethodsStrFilterGet = mapActions('ecampus', ['ActionsFilterGet'])
export const MethodsStrPost = mapActions('ecampus', ['ActionsPost'])
export const MethodsStrPut = mapActions('ecampus', ['ActionsPut'])
export const MethodsStrPutList = mapActions('ecampus', ['ActionsPutList'])
export const MethodsStrDelete = mapActions('ecampus', ['ActionsDelete']) 
export const MethodsStrSabitGet = mapActions('ecampus', ['ActionsSabitGet'])
export const MethodsActionsFileGet = mapActions('ecampus', ['ActionsFileGet'])

export const MethodsActionsLogin = mapActions('auth', ['ActionsLogin'])
export const MethodsResetPasswordLogin = mapActions('auth', ['ResetPasswordLogin'])
export const MethodsActionsAuth = mapActions('auth', ['ActionsAuth'])
export const MethodsActionsRefreshToken = mapActions('auth', ['ActionsRefreshToken'])
export const MethodsTokenZamaniHesaplama = mapActions('auth', ['TokenZamaniHesaplama']) 
export const MethodsActionsLoginSessionKey = mapActions('auth', ['ActionsLoginSessionKey'])  
export const MethodsActionsLoginManisa = mapActions('auth', ['ActionsLoginManisa'])  
export const MethodsTokenRefreshZamanKontrol = mapActions('auth', ['TokenRefreshZamanKontrol'])
export const MethodsUserUpdateLogin = mapActions('auth', ['UserUpdateLogin']) 
  